import React from "react";
import "./About.css";
import { Link } from "react-router-dom";
import teachers from "../../Assets/vectors/professor.svg";
export default function About() {
  return (
    <div className="grid grid2Fr about">
      <div className="content">
        <h3>About Us</h3>
        <h1>Our Guidance, Your Child's Future </h1>
        <p className="mt05" style={{ fontWeight: "500" }}>
          We help you to build your child's future! The educational programs of
          our school will give your child all the necessary skills and knowledge
          to make everything they learned here work for them in the future.
        </p>
        <Link to="/about">
          <button className="bt ripple mt2">Learn More</button>
        </Link>
      </div>
      <div className="p2 imageContainer">
        <img src={teachers} alt="" />
      </div>
    </div>
  );
}
